/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_item = {
    readonly serviceId: string | null;
    readonly isPublishedPrivate: boolean | null;
    readonly isPublishedExclusive: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubblePinterest_item" | "PdpSharedIconBubbleFacebook_item" | "PdpSharedIconBubbleEmail_item">;
    readonly " $refType": "PdpRespIconBubbles_item";
};
export type PdpRespIconBubbles_item$data = PdpRespIconBubbles_item;
export type PdpRespIconBubbles_item$key = {
    readonly " $data"?: PdpRespIconBubbles_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespIconBubbles_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isPublishedPrivate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isPublishedExclusive",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubblePinterest_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleFacebook_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_item",
      "args": null
    }
  ]
};
(node as any).hash = '5938ce305ce290c9afaa302b89a5ec46';
export default node;
